export function handleLabels() {
  const forms = [...document.querySelectorAll('.c-form')]

  const searchForm = [...document.querySelectorAll('.c-search__form > .c-form')]
  if (searchForm) {
    searchForm.forEach((form) => {
      const label = form.querySelector('label')
      const input = form.querySelector('input[type="text"]')
      if (input.value !== '') {
        label.classList.add('js-move-form-label')
      }
      input.addEventListener('focus', (e) => {
        label.classList.add('js-move-form-label')
      })
      input.addEventListener('blur', (e) => {
        if (input.value == '') {
          label.classList.remove('js-move-form-label')
        }
      })
    })
  }

  if (forms) {
    forms.forEach((form) => {
      const formRows = [...form.querySelectorAll('li')]
      // Perform initial check to correctly position labels after a failed ajax request
      formRows.forEach((row) => {
        const label = row.querySelector('label')
        const input = row.querySelector('input') || row.querySelector('textarea')
        if (input !== null && input.value !== '') {
          label.classList.add('js-move-form-label')
        }
      })

      // Add event listeners
      formRows.forEach((row) => {
        const label = row.querySelector('label')
        const input = row.querySelector('input') || row.querySelector('textarea')
        if (input !== null) {
          input.addEventListener('focus', (e) => {
            label.classList.add('js-move-form-label')
          })
          input.addEventListener('blur', (e) => {
            if (input != null) {
              if (input.value == '') {
                label.classList.remove('js-move-form-label')
              }
            }
          })
        }
      })
    })
  }
}

export function handlePasswordLabels() {
  const forms = [...document.querySelectorAll('.c-form')]

  if (forms) {
    forms.forEach((form) => {
      const formRows = [...form.querySelectorAll('.ginput_complex span')]
      // Perform initial check to correctly position labels after a failed ajax request
      formRows.forEach((row) => {
        const label = row.querySelector('label')
        const input = row.querySelector('input') || row.querySelector('textarea')
        if (input !== null && input.value !== '') {
          label.classList.add('js-move-form-label')
        }
      })

      // Add event listeners
      formRows.forEach((row) => {
        const label = row.querySelector('label')
        const input = row.querySelector('input') || row.querySelector('textarea')
        if (input !== null) {
          input.addEventListener('focus', (e) => {
            label.classList.add('js-move-form-label')
          })
          input.addEventListener('blur', (e) => {
            if (input != null) {
              if (input.value == '') {
                label.classList.remove('js-move-form-label')
              }
            }
          })
        }
      })
    })
  }
}

export function hideOnConfirmation() {
  const popup = document.querySelector('.c-popup--cta')
  const isConfirmed = popup.querySelector('.gform_confirmation_message')
  const title = popup.querySelector('.c-popup__title')
  const copy = popup.querySelector('.c-popup__copy')
  if (isConfirmed) {
    title.classList.add('u-is-hidden')
    copy.classList.add('u-is-hidden')
  }
}
